import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NavigationItem, SidebarMenuItem } from '../../models/common';

@Injectable()
export class SidebarService {
    public isOpen = true;
    public context: string;
    public toggleSubject = new Subject<boolean>();
    public existsSubject = new Subject<boolean>();
    public toggleStream: Observable<boolean> = this.toggleSubject.asObservable();
    public existsStream: Observable<boolean> = this.existsSubject.asObservable();
    private _menuItems: SidebarMenuItem[] = [];

    constructor() {
        this.toggleSubject.next(this.isOpen);
    }

    public get menuItems(): SidebarMenuItem[] {
        return this._menuItems;
    }

    public toggle(isOpen?: boolean): void {
        if (typeof isOpen !== 'undefined') {
            this.isOpen = isOpen;
        } else {
            this.isOpen = !this.isOpen;
        }
        this.toggleSubject.next(this.isOpen);
    }

    public init(): void {}

    public mapNavigationItemsToSidebarMenuItems(
        navigationItems: NavigationItem[],
        parentLabels: string[] = []
    ): SidebarMenuItem[] {
        if (!navigationItems) {
            return null;
        }
        return navigationItems.map((navigationItem) => {
            let featureFlags = [] as string[];
            if (navigationItem.featureFlags && navigationItem.featureFlags.length > 0) {
                featureFlags = navigationItem.featureFlags;
            }
            return new SidebarMenuItem({
                label: navigationItem.label,
                routerLink: navigationItem.routerLink,
                icon: navigationItem.icon,
                children: this.mapNavigationItemsToSidebarMenuItems(navigationItem.children),
                modal: navigationItem.modal,
                claims: navigationItem.claims,
                featureFlags
            });
        });
    }
}
